import AppLoadPageMixin from "@/protected/mixins/AppLoadPageMixin";
import Editor from "./CustomerEditor";
import service from "./CustomerService";

export default {
  mixins: [AppLoadPageMixin],

  components: {
    Editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.companyName;
    }
  }
};
